import WasmController from "react-lib/frameworks/WasmController";
// sequence
import * as SegmentI from "./sequence/Segment";
import * as SegmentTargetI from "./sequence/SegmentTarget";
export type State = {

} & SegmentI.State
 & SegmentTargetI.State

export const StateInitial: State = {
  ...SegmentI.StateInitial,
  ...SegmentTargetI.StateInitial
}

export type Event =
  | { message: "RunSequence"; params: any }
  | { message: "GetMasterData"; params: {} }
  | SegmentI.Event
  | SegmentTargetI.Event

  
export type Props = {

}

export type Data = {
};

export const DataInitial = {};

type Handler = (
  controller: WasmController<State, Event, Data, Props>,
  params?: any
) => any;